import "./style.scss";
import * as React from "react";
import * as _ from "lodash";

import Row from "../../../core/Row";
import Section from "../../../core/Section";
import { NavLink } from "react-router-dom";
import { Input, Button } from "antd";
import ShowRemainingMerchants from "./show_remaining_merchants";
import { Merchant } from "../../";
import { ViewMerchantsProps, ViewMerchantsActions } from "./container";
const Search = Input.Search;

// We used lunr because we were initially exploring filtering over 4000 merchants
// client-side and lunr performed favourably compared to other client-side search
// libraries
var lunr = require("lunr");

const LINKS = "#ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
const MERCHANTS_ON_PAGE = 3 * 14; // Num of Rows

interface MerchantPositions {
  [index: string]: number;
}

interface MerchantSearchInterface {
  value: string; // Search Value
  idx: any; // Lunr Search Idx
  merchantPositions: MerchantPositions; // Positions of Search Value
  searchResults: Merchant[];
}

class MerchantLinks extends React.Component<any, any> {
  handleClick(key: string) {
    this.props.handleClick(key);
  }

  render() {
    return (
      <div className="merchant-links">
        {this.props.links.map((key: string) => (
          <a key={key} onClick={this.handleClick.bind(this, key)}>
            {key}
          </a>
        ))}
      </div>
    );
  }
}

export const MerchantButton = (props: any) => {
  let logoUrl = "/flipp.png";
  let logoPath = props.merchant && props.merchant.large_image_path;
  if (logoPath && logoPath.length > 0) {
    if (logoPath.includes("http")) {
      logoUrl = logoPath.replace("https:", "").replace("http:", "");
    } else {
      logoUrl = `//images.wishabi.net/${logoPath}`;
    }
  }
  return (
    <NavLink
      to={{
        pathname: `/merchants/${props.merchant.id}`,
        state: { merchant_selection: true }
      }}
    >
      <div className="merchant-button" key={props.merchant.id}>
        <div className="merchant-logo">
          <img src={logoUrl} />
        </div>
        <div className="merchant-title">
          {props.merchant.name.split("_").join(" ")}
        </div>
      </div>
    </NavLink>
  );
};

class ViewMerchants extends React.Component<
  ViewMerchantsProps & ViewMerchantsActions,
  MerchantSearchInterface
> {
  constructor() {
    super();
    /*
     * Value             - Refers to the Search Input Field
     * merchantPositions - Object indexing name and position in Array of this.props.merchants
     * searchResults     - Search results returned by lunr
     */
    this.state = {
      value: "",
      idx: null,
      merchantPositions: null,
      searchResults: null
    };

    // Debounce function to add slight delay after user input and search, to provide
    // smooth experience
    this.handleChange = _.debounce(this.handleChange.bind(this), 350);
  }

  indexMerchants = (merchants: Merchant[]) => {
    // Index Merchants By Name
    let idx = lunr(function () {
      this.ref("name");
      this.field("name");

      merchants.forEach(function (doc: Merchant) {
        // Indexing items with spaces replaced with underscores,
        // appending underscore at end because of an issue that lunr
        // has with phrase matching
        doc.name = doc.name.split(" ").join("_");
        if (doc.name.substr(-1) != "_") {
          doc.name += "_";
        }
        this.add(doc);
      }, this);
    });

    // Create An Object Which We Can Use to find Position of Merchant Names In Props Arr
    let merchantPositions = {} as MerchantPositions;
    for (var i = 0; i < merchants.length; i++)
      merchantPositions[merchants[i].name] = i;

    this.setState({ idx: idx, merchantPositions: merchantPositions });
  };

  componentWillMount() {
    // load only if empty
    if (!this.props.merchants.length || this.props.merchants.length == 1)
      this.props.getMerchants("#");

    // index if index does not exist
    if (!this.state.idx) this.indexMerchants(this.props.merchants);
  }

  componentWillReceiveProps(nextProps: any) {
    if (nextProps.merchants) this.indexMerchants(nextProps.merchants);
  }

  renderMerchantList(merchants: Merchant[]) {
    return (
      <div className="contents">
        {merchants.map((merchant: Merchant) => (
          <MerchantButton merchant={merchant} key={merchant.id} />
        ))}
      </div>
    );
  }

  handleClick = (q?: string) => {
    // Implement client-side first letter filter
    let merchants = this.props.merchants.filter(function (merchant) {
      let firstLetter = merchant.name.slice(0, 1);
      return q == "#" ? parseInt(firstLetter) : firstLetter == q;
    });

    // Clear input field on click
    this.setState({ searchResults: merchants, value: "" });
  };

  handleChange(e: any) {
    // Qry Lunr Index
    // Phrase matching with lunr is not supported and we found better results
    // with single word search.
    let qry = `name:*${e.target.value}*`.split(" ").join("_");
    let results = this.state.idx.search(qry);

    let { merchantPositions } = this.state;
    let { merchants } = this.props;
    // Turn lunr search results into IMerchantProp[]
    let searchResults = results.map(function (result: any) {
      return merchants[merchantPositions[result.ref]];
    });

    this.setState({ searchResults: searchResults });
  }

  onChange = (e: any) => {
    e.persist();
    this.setState({ value: e.target.value });
    this.handleChange(e);
  };

  render() {
    let merchants = this.state.searchResults
      ? this.state.searchResults
      : this.props.merchants;
    merchants = _.orderBy(merchants, [(i) => i.name.toLowerCase()], ["asc"]);
    return (
      <div className="view-merchants">
        <Section className="view-merchants-section">
          <Search
            placeholder="Which retailer are you looking for?"
            type="text"
            value={this.state.value}
            className="merchant-search"
            onSubmit={(e: React.FormEvent<HTMLInputElement>) => {
              e.preventDefault();
            }}
            onChange={this.onChange}
          />
          <MerchantLinks
            links={LINKS}
            handleClick={this.handleClick.bind(this)}
          />
          {this.renderMerchantList(merchants.slice(0, MERCHANTS_ON_PAGE))}
          <ShowRemainingMerchants
            merchants={merchants}
            MERCHANTS_ON_PAGE={MERCHANTS_ON_PAGE}
          />
        </Section>
      </div>
    );
  }
}

export default ViewMerchants;



// WEBPACK FOOTER //
// ./client/modules/Merchant/components/ViewMerchants/component.tsx